module.exports = __webpack_public_path__ + "static/media/dashboardwithoutbg.e78c3948.svg";